import { GatewayAPIService } from '../../core/gateway-api.service';
import { StorageService } from '../../core/storage/storageService';
import { Injectable } from '@angular/core';
import { Page } from '../../components/ui/filterable-table/tableViewAbstractComponent';
import { ChargebackFacade } from './chargebackFacade';

@Injectable({
  providedIn: 'root',
})
export class ChargebacksService {
  //options = { authenticate: true, setRoot: true, updateAuthHeader: false };
  options = { authenticate: true, setRoot: true };

  constructor(
    private api: GatewayAPIService,
    private storage: StorageService,
  ) {}

  public getChargebacks(data: any): Promise<Page<ChargebackFacade>> {
    let usr = this.storage.getCurrentUser();

    if (usr) {
      data.userId = usr.id;
    }

    return this.api
      .apiCallSane(
        '/chargebacks',
        'GET',
        this.api.getDefaultHeaders(),
        data,
        null,
        this.options,
      )
      .then(
        (response: Partial<Page<ChargebackFacade>>) =>
          new Page<ChargebackFacade>(response),
      );
  }
}
